import rules from '../rules';
import { User } from '@types';

export default (role?: User.Roles) => {
  const parseRole = role ?? User.ROLES.client;
  return rules[parseRole];
};
